const methods = ['get', 'post', 'put', 'delete'];

function formatUrl(path = '') {
  return `${path[0] !== '/' ? '/' : ''}${path}`;
}

export default class ApiClient {
  constructor({ host = '' } = {}) {
    methods.forEach(
      method =>
        (this[method] = (path, { params, data } = {}) => {
          // if( !user.token ){
          //   return Promise.reject( new Error( 'no token' ));
          // }
          const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          };

          const opts = {
            method,
            headers
          };

          if (data) {
            opts.body = JSON.stringify(data);
          }

          const url = host + formatUrl(path, params);

          return fetch(url, opts).then(response => {
            if (response.status >= 200 && response.status < 300) {
              return response.json();
            }
            const err = new Error(`HTTP_${response.status}`);
            err.response = response;
            throw err;
          });
        })
    );
  }
}
